module.exports = __webpack_public_path__ + "img/rx-theta.bd27092c.svg";